/* SMR Header — sticky shadow + live cart sync.
   Reads cart URL from data attribute on header element. */
(function () {
  var headers = document.querySelectorAll('[data-smrhm-cart-url]');
  if (!headers.length) return;

  headers.forEach(function (el) {
    var cartUrl  = el.getAttribute('data-smrhm-cart-url') || '/cart';
    var cartLink = el.querySelector('[data-smrhm-cart-link]');

    /* Sticky shadow on scroll (matches original .header.scrolled) */
    function onScroll() {
      if (window.scrollY > 8) { el.classList.add('smrhm-scrolled'); }
      else { el.classList.remove('smrhm-scrolled'); }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    /* Live cart count refresh on AJAX cart-update events */
    function refreshCart() {
      if (!cartLink) return;
      fetch(cartUrl + '.js', {
        credentials: 'same-origin',
        headers: { 'Accept': 'application/json' }
      })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (c) {
          if (!c) return;
          var count    = c.item_count || 0;
          var existing = cartLink.querySelector('[data-smrhm-cart-count]');

          if (count > 0) {
            if (existing) {
              existing.textContent = count;
            } else {
              var span = document.createElement('span');
              span.className = 'smrhm-cart-badge';
              span.setAttribute('data-smrhm-cart-count', '');
              span.textContent = count;
              cartLink.appendChild(span);
            }
            cartLink.setAttribute(
              'aria-label',
              'Cart (' + count + ' item' + (count !== 1 ? 's' : '') + ')'
            );
          } else if (existing) {
            existing.remove();
            cartLink.setAttribute('aria-label', 'Cart (0 items)');
          }
        })
        .catch(function () { /* silent */ });
    }

    document.addEventListener('cart:updated',    refreshCart);
    document.addEventListener('cart:refresh',    refreshCart);
    document.addEventListener('cart:item-added', refreshCart);
    window.addEventListener('cart-updated',      refreshCart);

    /* Initial sync to catch any out-of-band cart state */
    refreshCart();
  });
})();
